import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/InterviewContext.css';

const Icon = {
  target: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
    </svg>
  ),
  building: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" /><line x1="9" y1="6" x2="9" y2="6" /><line x1="15" y1="6" x2="15" y2="6" /><line x1="9" y1="10" x2="9" y2="10" /><line x1="15" y1="10" x2="15" y2="10" /><line x1="9" y1="14" x2="15" y2="14" />
    </svg>
  ),
  layers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" />
    </svg>
  ),
  arrowLeft: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
    </svg>
  ),
  arrowRight: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
  )
};

const getInitials = (name = '') => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ROUNDS = ['Phone Screen', 'Round 1', 'Round 2', 'Round 3', 'Round 4', 'Technical', 'Behavioral', 'Final', 'Other'];

function InterviewContext({ profile, onContinue, onBack }) {
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState('');
  const [interviewRound, setInterviewRound] = useState('');

  const handleContinue = () => {
    if (!companyName.trim() || !interviewRound.trim()) {
      alert('Please enter both company name and interview round');
      return;
    }
    onContinue(companyName, interviewRound);
    navigate('/search');
  };

  const handleBack = () => {
    onBack();
    navigate('/profiles');
  };

  return (
    <div className="ic-page">
      <div className="ic-card">
        <div className="ic-header">
          <div className="ic-header-icon">{Icon.target}</div>
          <h1>Interview Details</h1>
          <p>Set the context for this preparation session</p>
        </div>

        <div className="ic-body">
          {/* Profile summary */}
          <div className="ic-profile">
            <div className="ic-avatar">{getInitials(profile.studentName)}</div>
            <div className="ic-profile-info">
              <h3>{profile.studentName}</h3>
              <div className="ic-profile-meta">
                <span>{profile.course}</span>
                <span className="ic-dot" />
                <span>{profile.yearsOfExperience} yrs exp</span>
                {profile.currentDesignation && <><span className="ic-dot" /><span>{profile.currentDesignation}</span></>}
              </div>
            </div>
          </div>

          <form onSubmit={(e) => { e.preventDefault(); handleContinue(); }}>
            <div className="ic-field">
              <label>Company Name <span className="ic-req">*</span></label>
              <div className="ic-input-wrap">
                <span className="ic-input-icon">{Icon.building}</span>
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  placeholder="e.g., Google, Amazon, Microsoft"
                  required
                />
              </div>
            </div>

            <div className="ic-field">
              <label>Interview Round <span className="ic-req">*</span></label>
              <div className="ic-chip-grid">
                {ROUNDS.map(round => (
                  <button
                    type="button"
                    key={round}
                    className={`ic-round-chip ${interviewRound === round ? 'active' : ''}`}
                    onClick={() => setInterviewRound(round)}
                  >
                    {round}
                  </button>
                ))}
              </div>
            </div>

            <div className="ic-actions">
              <button type="button" className="ic-btn ic-btn-ghost" onClick={handleBack}>
                {Icon.arrowLeft}<span>Back</span>
              </button>
              <button type="submit" className="ic-btn ic-btn-primary">
                <span>Continue to Search</span>{Icon.arrowRight}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default InterviewContext;
